// Source de vérité unique pour les types d'actifs (PAC / PV / Ballon / Batterie).
// La clé ECS est un alias historique de Ballon, conservée pour ne pas changer le
// rendu des écrans qui la référençaient (ClientDrawer, ClientDetailPage).
import { Flame, Sun, Droplets, BatteryCharging, Package, Thermometer, Radio } from 'lucide-react';

export const ICON = { PAC: Flame, PV: Sun, Ballon: Droplets, ECS: Droplets, Batterie: BatteryCharging, Radiateur: Thermometer };
export const LABEL = { PAC: 'PAC', PV: 'PV', Ballon: 'ECS', ECS: 'ECS', Batterie: 'Batterie', Radiateur: 'Radiateur' };
export const COLOR = { PAC: 'text-orange-500', PV: 'text-amber-500', Ballon: 'text-cyan-500', ECS: 'text-cyan-500', Batterie: 'text-violet-500', Radiateur: 'text-rose-500' };

// CE CHAMP NE PORTE PAS LA MEME CHOSE SELON LE TYPE, et « ID Équipement » ne
// permettait pas de savoir lequel recopier.
//
//   Batterie                  le numéro de série gravé sur l'étiquette, sous lequel
//                             elle publie sur le broker. Ce n'est PAS un ID Tuya.
//   PV                        l'ID central de l'installation dans Hoymiles S-Miles.
//   PAC / Ballon / Radiateur  le Device ID Tuya de l'appareil pilotable.
//
// Question posée par David le 27/08 : « c'est bien l'ID Tuya ? ». La réponse est
// « ça dépend », et c'est exactement le problème que ce libellé ferme.
//
// Vit ici plutôt que dans un écran depuis le 30/08 : la fiche client édite le même
// champ que le Monitoring, et le même matériel ne doit pas porter deux noms selon
// la porte d'entrée.
//
// ⚠️ LE PARCOURS POSEUR DIT AUTRE CHOSE, ET C'EST VOULU (26/10, lot L3). Sur CFTSign,
// David a fait retirer « Tuya » des libellés (« ID du thermostat », « ID du radiateur »,
// « ID de l'appareil pilotable ») : le poseur ne connaît pas ce nom, il l'égarait.
// Cette table ne sert que des écrans Flexcore de l'exploitant (fiche client,
// Monitoring), qui recopie cet identifiant dans la console Tuya ou le rattrapage : pour
// lui, « Tuya » est l'information. Ne pas aligner les deux sans redemander à David.
export const LIBELLE_IDENTIFIANT = {
  Batterie: 'N° de série (broker)',
  PV: 'ID central (S-Miles)',
  PAC: "ID Tuya de l'équipement",
  Ballon: "ID Tuya de l'équipement",
  Radiateur: "ID Tuya de l'équipement",
  defaut: "Identifiant de l'équipement",
};

// Variante carte (Leaflet) : couleurs hexadécimales + libellés longs.
export const ASSET_HEX_COLORS = { PAC: '#3B82F6', PV: '#F59E0B', Ballon: '#F97316', Batterie: '#8B5CF6', Radiateur: '#F43F5E' };
export const ASSET_FULL_LABELS = { PAC: 'Pompe à chaleur', PV: 'Panneaux solaires', Ballon: 'Ballon électrique', Batterie: 'Batterie', Radiateur: 'Radiateur électrique' };

// Variante SAV (distributeur) : label + Icon + classes de couleur/fond, avec un fallback "Autre".
export const SAV_TYPE_META = {
  PAC: { label: 'Pompe à chaleur', Icon: Flame, color: 'text-orange-500 bg-orange-50' },
  PV: { label: 'Panneaux solaires', Icon: Sun, color: 'text-amber-500 bg-amber-50' },
  Ballon: { label: 'Ballon ECS', Icon: Droplets, color: 'text-cyan-500 bg-cyan-50' },
  Batterie: { label: 'Batterie', Icon: BatteryCharging, color: 'text-violet-500 bg-violet-50' },
  // Le RADIATEUR manquait a cette table, alors que le serveur le connait
  // (TYPES_ACTIVABLES), que le wizard le pose et que la fiche chantier du
  // distributeur l'affiche deja avec ses trois variantes. Absent d'ici, un radiateur
  // s'affichait « Autre » : le depanneur qui prend l'appel ne savait pas quel
  // materiel il avait en face et devait rappeler l'installateur pour l'apprendre.
  // Les trois variantes sont reprises telles quelles de DistributorClientDetail.jsx :
  // le meme equipement ne doit pas porter deux noms selon l'ecran qui l'affiche.
  Radiateur: { label: 'Radiateur électrique', Icon: Thermometer, color: 'text-rose-500 bg-rose-50' },
  'Radiateur standard': { label: 'Radiateur standard', Icon: Thermometer, color: 'text-rose-500 bg-rose-50' },
  'Radiateur R2': { label: 'Radiateur R2', Icon: Radio, color: 'text-rose-600 bg-rose-50' },
  Autre: { label: 'Autre', Icon: Package, color: 'text-neutral-500 bg-neutral-100' },
};
